export default "__VITE_ASSET__329e6b0d__"